import React, { useState } from 'react'
import { Horizontal, Vertical } from '@gravitate-js/excalibrr'
import { Grid } from './components/Grid'
import { Table } from './components/Table'
import queryString from 'query-string'
import { useSecurityContext } from '@components/Navigation/SecurityContext'

export const PayMileageBands = () => {
  const [selectedRow, setSelectedRow] = useState(null)
  const table_id = queryString.parse(window.location.search).table_id
  const { scopes } = useSecurityContext()
  const canEdit = scopes.admin?.freight_write
  return (
    <Horizontal style={{ padding: '1rem', gap: '1rem', height: '100%', width: '100%' }}>
      <Vertical flex={2} style={{ height: '100%' }}>
        <Grid setSelectedRow={setSelectedRow} tableId={table_id} canEdit={canEdit} />
      </Vertical>

      <Vertical flex={1} className={'bordered'} style={{ borderRadius: '3px', height: '100%' }}>
        <Table selectedRow={selectedRow} canEdit={canEdit} setSelectedRow={setSelectedRow} />
      </Vertical>
    </Horizontal>
  )
}
